import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css']
})
export class DateComponent implements OnInit {

  // 抓取 Directive 本體
  @ViewChild(DaterangepickerDirective) pickerDirective!: DaterangepickerDirective;
  // 抓取 Input DOM 元素
  @ViewChild('dateInput') dateInput!: ElementRef;

  constructor(private cdRef: ChangeDetectorRef) {}

  @Input() time: any;
  @Input() timeset: any = [];
  @Input() limitset: any = [];
  @Input() type: any = false;
  @Input() auto: any = true;
  @Input() css: any = "width: 205px; display: inline-block; margin-right: 16px;";
  @Input() format: string = 'YYYY-MM-DD';

  @Output() rangeSelected = new EventEmitter<any>();
  @Output() showDatePickered = new EventEmitter<any>();
  @Output() open = new EventEmitter<any>();

  timePickerSeconds: boolean = false;
  minSelectable: any = 0;
  maxSelectable: any = 0;
  showDatePicker: boolean = false;
  ranges: any = {};

  ngOnInit(): void {
    if (this.format !== 'YYYY-MM-DD') {
        this.timePickerSeconds = true;
    }
    this.initRanges();
    this.initLimits();

    // ✅ 預設：7天前 ~ 今天
    const start = moment().subtract(7, 'days').startOf('day');
    const end = moment().endOf('day');
    this.time = { startDate: start, endDate: end };

    // 同步到 picker（如果已經存在）
    const picker: any = (this.pickerDirective as any)?.picker;
    if (picker) {
        picker.setStartDate(start);
        picker.setEndDate(end);
        picker.updateView?.();
        picker.updateCalendars?.();
    }


    // 同步 input 顯示文字
    this.syncInputText(start, end);
    if(!this.showDatePicker && !this.type){
        this.rangeSelected.emit({ event: this.time });
    }

  }

  // ✅ 手動輸入處理邏輯
  handleManualInput(event: any): void {
    const value = event.target.value;
    if (!value) return;

    const dateParts = value.split(' - ');
    if (dateParts.length === 2) {
      let start = moment(dateParts[0], this.format, true);
      let end = moment(dateParts[1], this.format, true);

      if (start.isValid() && end.isValid()) {
        // 若使用者把起訖打反了，自動交換（與 storyactive 一致）
        if (start.isAfter(end)) { const tmp = start; start = end; end = tmp; }

        // 冪等防護：解析出的範圍與目前值相同就不重複 emit
        // （避免點選日曆時若也觸發 blur → 父層 toggle/重查被打兩次）
        const cur: any = this.time || {};
        if (cur.startDate && cur.endDate) {
          const curStartStr = moment(cur.startDate).format(this.format);
          const curEndStr = moment(cur.endDate).format(this.format);
          if (curStartStr === start.format(this.format) && curEndStr === end.format(this.format)) {
            return;
          }
        }

        this.time = { startDate: start, endDate: end };

        // 使用 any 繞過 TypeScript 檢查，強制同步 Picker 狀態
        const picker: any = (this.pickerDirective as any).picker;
        if (picker) {
          picker.setStartDate(start);
          picker.setEndDate(end);
          picker.updateView?.();
          picker.updateCalendars?.();
        }

        this.syncInputText(start, end);
        this.rangeSelected.emit({ event: this.time });
      }
    }
  }

  // ✅ 補上你報錯中缺少的 syncInputText 方法
  private syncInputText(start: moment.Moment, end: moment.Moment): void {
    if (this.dateInput && this.dateInput.nativeElement) {
      const text = `${start.format(this.format)} - ${end.format(this.format)}`;
      this.dateInput.nativeElement.value = text;
    }
  }

  onRangeSelected(event: any): void {
    if (event.startDate && event.endDate) {
      this.rangeSelected.emit({ event });
    }
  }

  // --- 原有邏輯保持不變 ---
  initRanges() {
    this.ranges = (this.timeset || []).reduce((acc: any, curr: any) => {
      acc[curr.name] = this.calculateDateRange(curr.num, 'days', curr.type);
      return acc;
    }, {});
  }

  initLimits() {
    (this.limitset || []).forEach((element: any) => {
      if (element.type == 1) {
        this.minSelectable = moment().subtract(element.min, 'days');
        this.maxSelectable = moment().add(element.max, 'days');
      }
      if (element.type == 2) {
        this.minSelectable = moment(element.mindate);
        this.maxSelectable = moment(element.maxdate);
      }
    });
  }

  calculateDateRange(num: number, unit: any, type: any): [moment.Moment, moment.Moment] {
    let start = moment().add(num, unit).startOf(unit);
    let end = moment().endOf('day');
    if (type == 2) {
      start = moment().subtract(Math.abs(num), 'months').startOf('month');
      end = moment().subtract(Math.abs(num), 'month').endOf('month').endOf('day');
    }
    if (type == 3) end = start;
    if (type == 4) {
      start = moment().subtract(Math.abs(num), 'months').startOf('month');
      end = moment().endOf('day');
    }
    return [start, end];
  }

  toggleDatePicker(control: any): void {
    this.showDatePicker = !this.showDatePicker;
    if (control) {
      this.time = { startDate: null, endDate: null };
      this.rangeSelected.emit({ event: this.time });
      this.showDatePickered.emit({ event: this.showDatePicker });
    } else {
      this.open.emit({ event: this.showDatePicker });
    }
    this.cdRef.detectChanges();
  }
}
